export const ADMINISTRATOR_TEXT = "administrator";

// Preview RFQ constant
export const RFX_TABS = {
	ACCEPTED: "accepted",
	ADDENDUMS: "addendums",
	ALL_INVITED_SUPPLIER: "all",
	CLARIFICATIONS: "clarifications",
	COMMS: "comms",
	DECLINED: "declined",
	DOCUMENTATION: "documentation",
	EVALUATION: "evaluation",
	QUESTIONNAIRE: "returnable-schedules",
	QUOTE: "quote",
	SUBMITTED: "submitted",
	SUPPLIERS: "suppliers",
};

// RFQ Type Constants
export const RFQ_TYPES = {
	rfq: "Request For Quote",
	rfi: "Request For Information",
	rfp: "Request For Proposal",
	eoi: "Expression of Interest",
};

// RFQ Status constant

export const RFX_STATUS = {
	ACTIVE: "ACTIVE",
	COMPLETE: "COMPLETE",
	ON_HOLD: "ON_HOLD",
	ARCHIVED: "ARCHIVED",
	CANCELLED: "CANCELLED",
	SUSPENDED: "SUSPENDED",
	INVITED: "INVITED",
	SUBMITTED: "SUBMITTED",
	ACCEPTED: "ACCEPTED",
	EVALUATION: "EVALUATION",
	AWARDED: "AWARDED",
	DECLINE: "DECLINE",
	IN_PROGRESS: "INPROGRESS",
	DRAFT: "DRAFT",
	UNSUCCESSFUL: "UNSUCCESSFUL",
	// TODO: PRO-386 — split RFX_STATUS (RFx level) vs invite statuses in a future ticket
	BEING_REVISED: "BEING_REVISED",
};

// Addendum constant

export const STATUS_PRIVATE = "private";
export const STATUS_PUBLIC = "public";

// RFQ Profile

//image path
export const DEFAULT_IMAGE_BANNER = "/img/defaultimage.jpg";
export const DEFAULT_IMAGE_AVATAR = "/img/avatar-default.jpg";
export const PROFILE_TYPE_CLIENT = 1;
export const PROFILE_TYPE_HEAD_CONTRACTOR = 2;
export const PROFILE_TYPE_SUBCONTRACTOR = 3;
export const PROFILE_TYPE_CONSULTANT = 4;

export const CONTACT_US_URL = "https://procuracon.com.au/contact-form";
